export const containerTokens = {
  dark: {
    bg: 'bg.card',
    border: 'border.subtle',
    text: 'text.primary',
    textSecondary: 'text.secondary',
    buttonBorder: 'interactive.tertiary-border',
  },
  light: {
    bg: 'light.bg.card',
    border: 'light.border.subtle',
    text: 'light.text.primary',
    textSecondary: 'light.text.secondary',
    buttonBorder: 'light.interactive.tertiary-border',
  },
} as const
